module.exports = __webpack_public_path__ + "img/db6a3c199b19a4d3b6d8c98015d866a0.png";